import Vue from 'vue';
import Api from '../api.js';

const conferenceQry = `
query oneConf($id: Int!) {
  conference(id: $id) {
    conference_id
    name
    user_id
    conference_type
    record
    transcribe
    email_address
    instant
    share_with_account
    pins {
        pin
        is_admin
        is_active
        token
        url_token
        require_pin_as_password
    }
    users {
        user_id
        first_name
        last_name
        user_id
        username
    }
    ActiveSession {
      conference_session_id
      conference_id
      start_time
      end_time
    }
    Participants {
      conference_session_participant_id
      conference_session_id
      name
      email
      phone_number
      start_time
      end_time
      token
      is_caller
      is_admin
      is_rinble_phone
      is_muted
      bill_minutes
      bill_rate
      asterisk_uniqueid
      asterisk_channel
    }
  }
}
`;

const conferenceSubscriptionTxt = `
subscription onConferenceStatusChange($token: String!, $conferenceId: Int!) {
  conferenceStatusChange(token: $token, conferenceId: $conferenceId) {
    conference_id
    name
    user_id
    record
    transcribe
    instant
    email_address
    share_with_account
    conference_type
    pins {
        pin
        is_admin
        is_active
        token
        url_token
    }
    users {
        user_id
        first_name
        last_name
        user_id
        username
    }
    ActiveSession {
      conference_session_id
      conference_id
      start_time
      end_time
    }
    Participants {
      conference_session_participant_id
      conference_session_id
      name
      email
      phone_number
      start_time
      end_time
      token
      is_caller
      is_admin
      is_rinble_phone
      is_muted
      bill_minutes
      bill_rate
      asterisk_uniqueid
      asterisk_channel
    }
  }
}
`;

const vuexModule = {
    namespaced: true,
    
    state: {
        // Which session is currently active. 
        activeConferenceId: null,
        activeSpeakerChannelId: null,
        bridge: {},
        conferences: [{a:1},{b:2}],
        conference: {},
        instantConference: {},
        channels: [],
        myChannelId: null,
        conferenceLoading: false,
        pinPassword: null,
    },
    getters: {
        currentConference: (state) => {
            /*
            if (state.conferenceId) {
                for (let i = 0; i < state.conferences.length; i++) {
                    if (state.conferences[i].conference_id === state.conferenceId) {
                        return state.conferences[i];
                    }
                }
            }
            return null;
            */
           return state.conference;
        },
        myChannel: (state) => {
            // having defined properties helps vue with reactivity
            let emptyObj = {
                id: null,
                muted: false,
            };
            console.log('searching for myChannel in conference.js');
            if (!state.myChannelId) return emptyObj;
            for (let i=0;i<state.channels.length;i++) {
                let ch = state.channels[i];
                console.log('checking ' + ch.id + ' v ' + state.myChannelId);
                if (ch.id == state.myChannelId) {
                    console.log('found a channel ' + ch.id);
                    return ch;
                }
            }
            return emptyObj;
        },
    },
    mutations: {
        activeConferenceId: (state, val) => { state.activeConferenceId = val; },
        activeSpeakerChannelId: (state, val) => { state.activeSpeakerChannelId = val; },
        bridge: (state, val) => { state.bridge = val; },
        conference: (state, val) => { state.conference = val; },
        instantConference: (state, val) => { state.conference = val; },
        channels: (state, val) => {state.channels = val},
        pinPassword: (state, val) => {state.pinPassword = val},
        myChannelId: (state, val) => {state.myChannelId = val},
        addSubscriptionToCurrentConference: (state, { subscription, getters } ) => {
            // if the conference already had a subscription, unsubscribe
            if (state.conference.subscription) {
              state.conference.subscription.unsubscribe();
            }
            state.conference.subscription = subscription;
          },
        conferences: (state, val) => { 
            state.conferences = val;
            
            // there is only one instant conference, if there is one.
            state.instantConference = {};
            for (let i = 0; i < state.conferences.length; i++) {
                if (state.conferences[i].instant == 'Y') {
                    state.instantConference = state.conferences[i];
                }
            }
        },
        updateConferences: (state, conf) => {
            for (let i = 0; i < state.conferences.length; i++) {
                if (state.conferences[i].conference_id === conf.conference_id) {
                
                    // we stuffed the subscription inside the conference object
                    // in another part of the code. take it and put it in the new object
                    if (state.conferences[i].subscription) {
                        const sub = state.conferences[i].subscription;
                        conf.subscription = sub;
                    }

                    state.conferences[i] = conf;
                }
            }
            state.conference = conf;
            if (conf.instant == 'Y') {
                state.instantConference = conf;
            }
        },
        updateConferenceWithSIPMessage: (state, val) => {
            console.log(val);
            for (let i = 0; i < state.conferences.length; i++) {
                if (state.conferences[i].conference_id === state.conference.conference_id) {
                    let currentConference = state.conferences[i];
                    Vue.set(currentConference, 'channels', val.channels);
                    Vue.set(currentConference, 'bridge', val.bridge);

                    // trigger reactivity on the getter for currentConference
                    // which is triggeerd off of the conferenceId
                    const id = state.conferenceId;
                    state.conferenceId = null;
                    state.conferenceId = id;
                }
            }
        },
    },
    actions: {
        async getConference({ commit, state }, conferenceId=null) {
            const confQry = global.gql(conferenceQry);
            console.log('getting conference ' + conferenceId);
            const variables = { id: conferenceId ? conferenceId : parseInt(state.conference.conference_id) };
            let result = await global.apollo.query({ query: confQry, variables, fetchPolicy: 'network-only' });
            if (!result) return;
            commit('updateConferences', result.data.conference);
            return true;
        },
        subscribeToConference({ commit, state, getters }) {
            const subqry = global.gql(conferenceSubscriptionTxt);
            const sub = global.apollo.subscribe({
                query: subqry,
                variables: { conferenceId: parseInt(state.conference.conference_id), token: localStorage.getItem('authorizationToken') },
            }).subscribe({
                next (data) {
                // Notify your application with the new arrived data
                commit('updateConferences', data.data.conferenceStatusChange);
                },
            });
            commit('addSubscriptionToCurrentConference', { subscription: sub, getters });
        },
        unsubscribeFromCurrentConference({getters, state}) {
            
            // we stuffed the apollo subscription object inside the conference object
            if (state.conference.subscription) {
                state.conference.subscription.unsubscribe();
            }
        },
        async getConferences({ commit, dispatch, state, rootState }) {
            if (!rootState.user) return;
            if (rootState.user.user_id == 'guest') return;
            state.conferenceLoading = true;
            let api = new Api(global.gqlClient());
            let result = await api.myConferences();
            state.conferenceLoading = false;
            if (!result) return;
            commit('conferences', result.data.myConferences);
            return true;
        },
        async setConferenceByUrlToken({commit, state}, params) {
            let api = new Api(global.gqlClient());
            let result = await api.confrenceFromUrlToken(params.token, params.pin);
            commit('updateConferences', result);
            return true;
        }
    },
};

export default vuexModule;